module.exports = {"id":"197391","name":"Lars Vilsvik","rating":"72","photo":"./data/images/photos/4/197391.png","club":{"name":"Strømsgodset IF","logo":"./data/images/clubs/StrømsgodsetIF.png"},"positions":["DD","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LarsVilsvik0.json
// module id = 2430
// module chunks = 0